export default __webpack_public_path__ + "static/media/step_015.23852564.jpeg";